<template>
  <div class="col-lg-4 col-md-6 col-12" style="padding-bottom: 30px;">
    <div class="itemcard downloadcard" style="
    padding: 0;
    overflow: hidden;
        height: 100%;
">
      <img
        src="https://cdn.proxyscrape.com/img/proxy_rotation.jpg"
        style="width: 100%;
        max-height: unset;
        min-height: unset;
        min-width: unset;"
        alt=""
      />
      <div style="padding: 0 30px;">
        <h2>Rotating Proxies</h2>
        <p style="text-align: left;">
          Proxy rotation is a fantastic feature of back-connect proxies.
          Each time you connect to our endpoint, our network will assign you a random
          proxy, ensuring you will get the best possible results without being blocked.
        </p>
      </div>
    </div>
  </div>

  <div
    class="col-lg-4 col-md-6 col-12"
    style="padding-bottom: 30px;">
    <div
      class="itemcard downloadcard"
      style="
      padding: 0;
      overflow: hidden;
      height: 100%;">
      <img
        src="https://cdn.proxyscrape.com/img/proxy_pool.jpg"
        style="
        width: 100%;
        max-height: unset;
        min-height: unset;
        min-width: unset;" alt="" />
      <div style="padding: 0 30px;">
        <h2>7 million pool</h2>
        <p style="text-align: left;">
          With our 7 million proxy pool combined with our proxy endpoint, you will never
          have to worry about running out of proxies that will work for your target
          website.
        </p>
      </div>
    </div>
  </div>

  <div
    class="col-lg-4 col-md-6 col-12"
    style="padding-bottom: 30px;">
    <div
      class="itemcard downloadcard"
      style="padding: 0;
      overflow: hidden;
      height: 100%;">

      <img
        src="https://cdn.proxyscrape.com/img/global_proxies.jpg"
        style="width: 100%;
        max-height: unset;
        min-height: unset;
        min-width: unset;"
        alt="" />

      <div style="padding: 0 30px;">
        <h2>Global proxies</h2>
        <p style="text-align: left;">
          The ProxyScrape global residential network has you covered with over 129 countries
          worldwide. You will be sure to find the country you need in our residential network!
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>

</script>

<style scoped>

</style>
